var map = {
	"./404.js": 781,
	"./accessibility.js": 782,
	"./careers.js": 783,
	"./code-of-practice.js": 784,
	"./cookies.js": 786,
	"./disclaimer.js": 787,
	"./energy.js": 788,
	"./environment.js": 789,
	"./jd-foundation-brouchure.js": 790,
	"./jd-foundation-latest-news.js": 791,
	"./jd-foundation-social-impact-report.js": 792,
	"./jd-foundation.js": 793,
	"./our-committees.js": 794,
	"./our-people.js": 795,
	"./our-policies.js": 796,
	"./our-strategy.js": 797,
	"./privacy.js": 798,
	"./supply-chain.js": 799,
	"./sustainability.js": 800,
	"./tax-strategy.js": 801
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 780;